import { useQuery } from '@tanstack/react-query';

import { listAllKubernetesScopedKubeconfigs } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

import { ScopedKubeconfig } from '../types';

import { queryKeys } from './query-keys';

/**
 * Scoped kubeconfigs across every environment. The API filters by ownership, so
 * an administrator is served everyone's and anyone else only their own.
 */
export function useAllScopedKubeconfigs<T = ScopedKubeconfig[]>({
  select,
  enabled,
}: { select?: (data: ScopedKubeconfig[]) => T; enabled?: boolean } = {}) {
  return useQuery({
    queryKey: queryKeys.all(),
    queryFn: getAllScopedKubeconfigs,
    ...withError('Unable to retrieve scoped kubeconfigs'),
    select,
    enabled,
  });
}

async function getAllScopedKubeconfigs(): Promise<ScopedKubeconfig[]> {
  const { data } = await listAllKubernetesScopedKubeconfigs();

  return data ?? [];
}
